// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"9a2773c3","100":"e7ec5865","315":"4655082a","403":"04ec382a","406":"54df88f4","502":"5d21a5a9","532":"48a7103b","745":"4238ad36","762":"2e095311"}[chunkId] + ".chunk.js";
};